import { getDisplayName } from '../helpers';
import { addValidation } from '../Validation';

function buildNumberValueValidator(
  condition: (value: number, limit: number) => boolean,
  defaultMessage: string,
) {
  return (
    limit: number,
    message = defaultMessage,
    type: 'price' | 'number' = 'number',
  ) => {
    return (target: any, fieldName: string) => {
      const validation = {
        fieldName,
        validateFunction: (obj: any) => {
          const name = getDisplayName(obj, fieldName);
          const value =
            type === 'number' ? obj[fieldName] : obj[fieldName] / 100;
          const numberValue = Number(value);
          const isValid = !isNaN(numberValue) && condition(numberValue, limit);

          return isValid
            ? undefined
            : {
                message,
                data: {
                  name,
                  value,
                  limit,
                },
              };
        },
      };

      addValidation(target, fieldName, validation);
    };
  };
}

export const isNumberLess = buildNumberValueValidator(
  (value, limit) => value < limit,
  'validator.message.isNumberLess',
);
export const isNumberLessOrEqual = buildNumberValueValidator(
  (value, limit) => value <= limit,
  'validator.message.isNumberLessOrEqual',
);
export const isNumberMore = buildNumberValueValidator(
  (value, limit) => value > limit,
  'validator.message.isNumberMore',
);
export const isNumberMoreOrEqual = buildNumberValueValidator(
  (value, limit) => value >= limit,
  'validator.message.isNumberMoreOrEqual',
);
